import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronRightSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0002 6.58594L15.4144 12.0002L10.0002 17.4144L8.58594 16.0002L12.5859 12.0002L8.58594 8.00015L10.0002 6.58594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRightSmall;
